export enum AnalysisReportPrintDataOptionsType {
    DoNotPrint,
    SingleLineItem,
    EntirePhase,
    EntireCase
}

export enum AnalysisReportPrintDataOptionsTypeStrings {
    DoNotPrint = 'Do Not Print',
    SingleLineItem = 'Single Line Item Only',
    EntirePhase = 'Entire Phase Data',
    EntireCase = 'Entire Case Data'
}